import * as t from '../types'
import createAlgoliaHelper from 'utils/createAlgoliaHelper'
import config from 'config'
import slugify from 'utils/slugify'

/** @firescoutMockFn productDetail.fetch */
export const fetch = async (
  filterValues: t.FilterValues
): Promise<t.api.Fetch> => {
  const helper = await createAlgoliaHelper(config.index.products, {
    facets: ['containerID'],
    disjunctiveFacets: ['active'],
    distinct: 0,
    attributesToRetrieve: [
      'sku',
      'sw6Uuid',
      'brand',
      'containerID',
      'variantData',
      'categories',
      'shippingFree',
      'attributes',
      'images',
      'specialDelivery',
      'prices',
      'priceRules',
      'unit',
      'title',
      'channelActive',
      'subtitle',
      'description',
      'descriptionAI',
      'stock',
      'sellOut',
      'deliveryDate',
      'deliveryDays',
      'flags',
      'sellable',
      'documents',
      'related',
      'product_line',
      'series',
      'hreflangData',
      'specimen',
      'mainCategory',
      'configurations',
      'isMeterware',
      'isMainVariant',
      'isPartnerItem',
      'productReviews',
      'sizeChartData',
      'temporaryDelisted',
      'descriptionAI'
    ]
  })
  helper.addFacetRefinement('containerID', filterValues.containerID)
  helper.addDisjunctiveFacetRefinement('active', 'true')

  helper.setQueryParameter('analyticsTags', ['pdp-root-query'])

  const result = await helper.searchOnce({ hitsPerPage: 1000 })

  //Returns channelActive default true for b2b/b2c to ensure they can't be null
  result.content.hits.forEach((item, i) => {
    result.content.hits[i] = {
      ...item,
      channelActive: {
        b2c: item.channelActive?.b2c ?? true,
        b2b: item.channelActive?.b2b ?? true
      },
      hrefLang: item.hreflangData
        ? Object.keys(item.hreflangData).map((entry) => {
            return {
              url: `${config.baseUrl}/${entry.replace('_', '-').toLowerCase()}/pdp/${item.containerID}/`,
              hrefLang: entry.replace('_', '-')
            }
          })
        : []
      /*
       * Ab [WDV-3916] "sprechende URL's" diese utility function nutzen !!!
       * hrefLang: calculateHrefLang({hrefLangData: item.hreflangData, pageType: 'pdp', containerID: item.containerID})
       */
    }
    delete result.content.hits[i].hreflangData
  })

  return result.content.hits
}
